/* eslint-disable react/prop-types */
// import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Box, TableCell, TableRow, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InputField from "../../../components/common/new/InputField/InputField";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import Table from "../../../components/common/new/Table/Table";
import { Constants, MARK_ATTENDANCE, PERMISSIONS } from "../../../contants";
import { INITIATE_VIEW_FAMILY_DATA } from "../../../redux/actionTypes/dashboard";
import { ROUTES } from "../../../utils/constants";
import { performOperation } from "../../member/MemberSearch/utils";
import { style, tabelCellWidth } from "./FamilyDetailsList.styles";
import Button from "../../../components/common/Button/index";
import useUserConfig from "../../../hooks/useUserConfig";
import Typography from "../../../components/common/new/Typography/Typography";
import { familyLoading } from "../../../redux/selectors/family";
import Loader from "../../../components/common/Loader/Loader";

const getRows = (data, onEditClick, onViewClick, hasPermission) =>
  data?.map((memberData) => (
    <TableRow>
      {/* <TableCell style={{ ...style.rowStyleId, ...tabelCellWidth.medium }}>
        <Typography variant="small" color="#043D90">
          {memberData?.familyId}
        </Typography>
      </TableCell> */}
      <TableCell style={style.rowStyle}>
        <Typography variant="small" color="#183053">
          {memberData.areaName}
        </Typography>{" "}
      </TableCell>
      <TableCell style={style.rowStyle}>
        <Typography variant="small" color="#183053">
          {memberData.zoneName}
        </Typography>
      </TableCell>
      <TableCell style={style.rowStyle}>
        <Typography variant="small" color="#183053">
          {memberData.regionName}
        </Typography>
      </TableCell>
      <TableCell style={{ ...style.rowStyle, ...tabelCellWidth.medium }}>
        <Typography variant="small" color="#183053">
          {memberData.familyMembers.reduce(
            (acc, curr) => `${acc} ${curr.fullName},`,
            ""
          )}
        </Typography>
      </TableCell>
      <TableCell style={{ ...style.rowStyle, ...tabelCellWidth.small }}>
        <Typography variant="small" color="#183053">
          {memberData.familyAddress}{" "}
        </Typography>
      </TableCell>
      <TableCell style={{ color: "rgba(140, 140, 140, 1)" }}>
        <Box style={style.flexC}>
          <Tooltip title="View">
            <RemoveRedEyeOutlinedIcon
              style={style.icon}
              onClick={() => {
                onViewClick(memberData?.familyId, `preview`);
              }}
            />
          </Tooltip>
          {hasPermission(PERMISSIONS.UPDATE_FAMILY) && (
            <Tooltip title="Edit">
              <EditOutlinedIcon
                style={style.icon}
                onClick={() => onEditClick(memberData?.familyId)}
              />
            </Tooltip>
          )}
          {/* <DeleteOutlinedIcon /> */}
        </Box>
      </TableCell>
    </TableRow>
  ));

function FamilyDetailsList() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const familyInfo = useSelector((state) => state.view_family.data);
  const dispatch = useDispatch();
  const hasPermission = useUserConfig();
  const paginationInfo = useSelector(
    (store) => store.view_family.paginationInfo
  );

  const isLoading = useSelector(familyLoading);

  const onSearchClick = async (
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE
  ) => {
    const query = {
      inOrganisationStructure: true,
      [Number.isNaN(Number(searchQuery)) ? "memberName" : "memberId"]:
        searchQuery,
    };

    dispatch({
      type: INITIATE_VIEW_FAMILY_DATA,
      payload: { params: { page: pageNumber, pageSize }, query },
    });
  };

  const onPaginationClick = (page) => {
    const { pageSize } = paginationInfo;
    onSearchClick(page, pageSize);
  };

  const onPageSizeClick = (operator) => {
    const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      pageSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    onSearchClick(0, newPageSize);
  };

  const onEditClick = (familyId, params = "") => {
    navigate(`/family/edit/${familyId}${params ? `/${params}` : ""}`);
  };

  const onViewClick = (familyId, params = "") => {
    navigate(`/family/view/${familyId}${params ? `/${params}` : ""}`);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    onSearchClick();
  };

  useEffect(() => {
    onSearchClick();
  }, []);

  return (
    <div style={{ ...style.container }}>
      <div style={{ ...style.headerContainer, marginRight: "20px" }}>
        <div style={style.title}>Family Details</div>
        <div style={{ ...style.inputContainer, ...style.headerContainer }}>
          <form onSubmit={onSubmit}>
            <InputField
              style={style.SearchInput}
              name="search"
              value={searchQuery}
              placeholder="Member Name/ID"
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              variant="contained"
              label="Search"
              style={{ marginTop: "14px" }}
              type="submit"
            />
          </form>
          {hasPermission(PERMISSIONS.CREATE_NEW_FAMILY) && (
            <Button
              variant="contained"
              style={{ marginLeft: "12px" }}
              onClick={() => {
                navigate(`/${ROUTES.CREATE_NEW_FAMILY.path}`);
              }}
              label="ADD FAMILY"
            />
          )}
        </div>
      </div>
      <Box style={style.tableHeading}>
        <Box />
        <Box style={style.tableInfo}>
          Total Families: {paginationInfo.totalElements}
        </Box>
      </Box>
      {familyInfo.length ? (
        <>
          <Table
            scrollable
            columns={MARK_ATTENDANCE}
            columnCellStyle={{ textAlign: "left", paddingLeft: "20px" }}
            title="ALL_MEMBERS"
            rows={getRows(familyInfo, onEditClick, onViewClick, hasPermission)}
            hasPermission
            tableBodyTheme="#F6F6F6"
            tableHeadCellStyle={{
              ...style.tableHeadCells,
              // textAlign: "left",
            }}
          />
          <Box style={style.pagination}>
            <Pagination
              totalPages={paginationInfo.totalPages}
              totalResults={paginationInfo.totalElements}
              currentPage={paginationInfo.currentPage}
              pageSize={paginationInfo.pageSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          </Box>
        </>
      ) : (
        !isLoading && (
          <Box style={style.emptyContainer}>
            <h1 style={style.noDataMsg}>No Results</h1>
          </Box>
        )
      )}
      {isLoading && <Loader />}
    </div>
  );
}

export default FamilyDetailsList;
